import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchBTLLeadsData } from "../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { formatTimezoneThenStraight } from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../lead-management/AddLeadForm";
import LeadFollowupV1 from "../lead-management/followup/LeadFollowupV1";
import { getReplace1 } from "../common-data/Conversions";
import CmnFilters from "../lead-management/common/CmnFilters";
import ModalCloseStart from "../payouts-wtf/common/ModalCloseStart";
import LeadJourney from "../lead-management/lms-v2/lead-journey/LeadJourney";
import ClickToCall from "../lead-management/lms-v2/lms-payment-links/ClickToCall";
import { CallIcon } from "../../images/icons/icons";

const BTLLeads = ({ userInfoData, prevAllFilters }) => {
  const dispatch = useDispatch();
  const { leadsBTL, leadsBTLLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: prevAllFilters.selectedGym
      ? prevAllFilters.selectedGym
      : !isAdmin && !isClusterManager
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedVendor: "",
    selAddNotAddToLead: "",
    leadAddDateFrom: "",
    leadAddDateTo: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    vendor_id: allFilters.selectedVendor?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function closeModal() {
    setModValues(iniModvalues);
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getBTLLeads(filters) {
    dispatch(
      fetchBTLLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getBTLLeads(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      vendor_id: allFilters.selectedVendor?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedVendor,
    allFilters.selAddNotAddToLead,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
  ]);

  useEffect(() => {
    if (leadsBTL?.status && leadsBTL?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: leadsBTL.data,
        pagination: leadsBTL?.pagination?.length > 0 ? leadsBTL.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [leadsBTL]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  const tbColumns = [
    {
      dataField: "added_to_lead",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          {row?.added_to_lead ? (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#000",
                color: "#fff",
                borderRadius: "8px",
                cursor: row?.added_to_lead ? "pointer" : "not-allowed",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  // modName: "follow-up",
                  modName: "view-lead-journey",
                }))
              }
            >
              View Lead
            </button>
          ) : (
            <button
              type="button"
              className="actionBtn"
              style={{
                minWidth: "120px",
                background: "#C90808",
                color: "#fff",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "15px",
                padding: "10px",
              }}
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  rowData: row,
                  modName: "add-to-lead",
                }))
              }
            >
              Add To LMS
            </button>
          )}
        </div>
      ),
    },
    {
      dataField: "lead_id",
      text: "lead Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.mobile || ""}
              <br />
              {row?.email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "vendor_id",
      text: "vendor Info",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.vendor_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.vendor_mobile || ""}
              <br />
              {row?.vendor_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.date_added ? formatTimezoneThenStraight(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "click_to_call",
      text: "Action",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "click-to-call",
                  rowData: row,
                }))
              }
            >
              <CallIcon color="#000" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "add-to-lead"
              ? "p-0 mod-width-50p mod-height-95vh"
              : modValues.modName === "view-lead-journey"
              ? "mod-height-95vh mod-width-70p"
              : modValues.modName === "click-to-call"
              ? "mod-height-95vh mod-width-70p p-0 m-0 bg-white"
              : ""
          }`}
        >
          {modValues.modName === "add-to-lead" ||
          modValues.modName === "click-to-call" ? null : modValues.modName ===
            "follow-up" ? (
            <ModalCloseStart
              title={`${getReplace1(modValues.modName)}`}
              onClose={() => {
                closeModal();
                getBTLLeads(filters);
              }}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <ModalCloseStart
              title={`Lead Details - ${modValues.rowData?.name || ""}`}
              onClose={() => {
                closeModal();
                getBTLLeads(filters);
              }}
            />
          ) : (
            <ModalHeadAndClose
              title={`${getReplace1(modValues.modName)}`}
              onClose={closeModal}
            />
          )}

          {modValues.modName === "add-to-lead" ? (
            <AddLeadForm
              userInfoData={userInfoData}
              closeModal={closeModal}
              callFunction={() => {
                getBTLLeads(filters);
              }}
              rowData={modValues.rowData}
              isBTL={true}
            />
          ) : modValues.modName === "follow-up" ? (
            <LeadFollowupV1
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeFollowupModal={closeModal}
              isBTL={true}
              isAllLeadDetails={true}
              pageName="btl"
              prevFilters={(({ limit, page, added_to_lead, ...rest }) => rest)(
                filters
              )}
            />
          ) : modValues.modName === "view-lead-journey" ? (
            <LeadJourney
              userInfoData={userInfoData}
              rowData={modValues.rowData}
            />
          ) : modValues.modName === "click-to-call" ? (
            <ClickToCall
              userInfoData={userInfoData}
              closeModal={closeModal}
              rowData={modValues.rowData}
            />
          ) : null}
        </div>
      </Modal>

      <CmnFilters
        from={"btl-leads"}
        userInfoData={userInfoData}
        onClickReset={onResetFilters}
        filters={allFilters}
        setFilters={setAllFilters}
        onClickSearch={onClickSearch}
        searchFilterApplied={searchFilterApplied}
        isLoading={leadsBTLLoading}
      />

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30">
        {leadsBTLLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default BTLLeads;
